import React from "react";
import { useSubscription } from "../subscriptions/TaxDocumentsSub";

import { makeStyles } from "@material-ui/core/styles";
import { List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText } from "@material-ui/core";
import { Storage } from "aws-amplify";

import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import AttachmentIcon from "@material-ui/icons/Attachment";
import DeleteIcon from "@material-ui/icons/Delete";

import { API, graphqlOperation } from "aws-amplify";
import { deleteTaxDocument } from "../graphql/mutations";
import { downloadBlob } from "./FileDownload";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
}));

/*
import ContactForm from "../components/contact-form";
import ContactTable from "../components/contact-table";
*/

export default function TaxDocumentList(props) {
  let attachments = null;

  attachments = useSubscription(props);

  console.log("Attachments in List Subscriber1:", attachments);

  const classes = useStyles();

  const handleDelete = async (e, attachment) => {
    console.log("Delete Clicked:", attachment);
    //Delete from S3
    //Delete GraphQL

    async function deleteAttachmentDB(attachment) {
      const input = {
        id: attachment.id,
      };
      await API.graphql(graphqlOperation(deleteTaxDocument, { input: input }));
    }
    deleteAttachmentDB(attachment);
  };

  const handleDownload = async (e, attachment) => {
    console.log("Delete Clicked:", attachment);
    //Delete from S3
    //Delete GraphQL

    async function downloadAttachment(attachment) {
      try {
        await Storage.get(attachment.s3key, {
          download: true,
          level: "public",
        }).then((res) => downloadBlob(res.Body, attachment.fileName));
      } catch (err) {
        console.log("error: ", err);
      }
    }
    downloadAttachment(attachment);
  };
  return (
    <div className={classes.demo}>
      <List dense={true}>
        {attachments.map((attachment, i) => (
          <ListItem key={attachment.id} button component="a" href="#" onClick={(evt) => handleDownload(evt, attachment)}>
            <ListItemAvatar>
              <Avatar>
                <AttachmentIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={attachment.fileName} />
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="delete" onClick={(evt) => handleDelete(evt, attachment)}>
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </div>
  );
  /*  return (    
      <div>
        <h1>Attachments</h1>
        {
          attachments.map((attachment, i) => <p key={i}>{attachment.fileName}</p>)
        }
      </div>
    );
  */
}
